export const PET_PATH_SEPARATOR = ' > ';

/** Cross-cutting filter — not part of the category tree. */
export const PET_TYPES = [
  'Dogs',
  'Cats',
  'Birds',
  'Fish',
  'Rabbits',
  'Hamsters',
  'Guinea Pigs',
  'Reptiles',
  'Horses',
  'Farm Animals',
  'Other Pets',
];

export const PET_SUPPLIES_CATEGORY_TREE = {
  'Beds & Furniture': {
    Beds: ['Standard Beds', 'Orthopedic Beds', 'Cooling Beds', 'Heated Beds'],
    Furniture: ['Pet Sofas', 'Pet Chairs', 'Window Perches'],
    'Cat Furniture': ['Cat Trees & Towers', 'Scratchers', 'Scratching Posts', 'Cat Shelves'],
    'Houses & Shelters': ['Pet Houses', 'Kennels', 'Outdoor Shelters'],
  },
  'Carriers & Travel': {
    Carriers: ['Soft Carriers', 'Hard Carriers', 'Airline Approved Carriers'],
    'Travel Accessories': ['Travel Bags', 'Pet Backpacks', 'Strollers'],
    'Vehicle Safety': ['Car Seat Covers', 'Vehicle Restraints', 'Booster Seats'],
    Containment: ['Crates', 'Playpens', 'Travel Pens'],
  },
  'Collars, Harnesses & Leashes': {
    Collars: ['Standard Collars', 'Training Collars', 'Reflective Collars'],
    Harnesses: ['Front Clip Harnesses', 'Back Clip Harnesses', 'No-Pull Harnesses'],
    Leashes: ['Standard Leashes', 'Retractable Leashes', 'Hands-Free Leashes'],
    'Identification & Tracking': ['ID Tags', 'GPS Trackers', 'Smart Trackers'],
  },
  'Feeding Supplies': {
    Bowls: ['Feeding Bowls', 'Water Bowls', 'Elevated Feeders'],
    'Automatic Feeding': ['Automatic Feeders', 'Smart Feeders'],
    Hydration: ['Water Fountains', 'Water Dispensers'],
    'Feeding Accessories': ['Feeding Mats', 'Food Storage Containers'],
  },
  Toys: {
    'Play Toys': ['Balls', 'Plush Toys', 'Rope Toys'],
    'Interactive Toys': ['Puzzle Toys', 'Smart Toys'],
    'Chew Toys': ['Rubber Chews', 'Dental Chews'],
    'Cat Toys': ['Wand Toys', 'Laser Toys'],
  },
  'Litter & Waste Management': {
    'Litter Boxes': ['Open Litter Boxes', 'Covered Litter Boxes', 'Self-Cleaning Litter Boxes'],
    'Litter Accessories': ['Litter Mats', 'Scoops'],
    'Waste Management': ['Waste Disposal Systems', 'Waste Bag Dispensers'],
    'Training Pads': ['Puppy Pads', 'Reusable Pads'],
  },
  'Cages, Aquariums & Habitats': {
    Cages: ['Bird Cages', 'Small Animal Cages'],
    Aquariums: ['Freshwater Aquariums', 'Saltwater Aquariums'],
    'Aquarium Equipment': ['Aquarium Filters', 'Aquarium Decorations'],
    Terrariums: ['Reptile Terrariums', 'Amphibian Habitats'],
    'Habitat Accessories': [
      'Bird Perches',
      'Bird Swings',
      'Reptile Habitat Accessories',
      'Habitat Decorations',
    ],
  },
  'Grooming Equipment': {
    'Grooming Tools': ['Brushes & Combs', 'Deshedding Tools'],
    'Nail Care': ['Nail Clippers', 'Nail Grinders'],
    'Professional Equipment': ['Grooming Tables', 'Dryers'],
    'Other Grooming Equipment': ['Other'],
  },
  'Training Accessories': {
    'Training Tools': ['Clickers', 'Whistles'],
    'Barriers & Safety': ['Gates & Barriers'],
    'Pads & Training Aids': ['Training Pads', 'Potty Training Systems'],
    'Agility Equipment': ['Tunnels', 'Jumps'],
  },
  'Pet Clothing': {
    'Everyday Wear': ['Shirts', 'Sweaters', 'Hoodies'],
    'Outdoor Wear': ['Jackets', 'Raincoats'],
    Footwear: ['Pet Shoes & Boots'],
    'Special Occasion': ['Costumes', 'Formal Wear'],
  },
  'Pet Accessories': {
    Identification: ['ID Tags', 'Name Plates'],
    'Fashion Accessories': ['Bandanas', 'Bows', 'Bow Ties'],
    'Safety Accessories': ['Reflective Accessories', 'Safety Lights'],
    'Storage & Organization': ['Pet Storage & Organizers'],
    'Replacement Parts & Accessories': ['Carrier Parts', 'Crate Parts', 'Fountain Parts'],
    'Other Pet Accessories': ['Other'],
  },
  'Pet Technology': {
    Monitoring: ['Pet Cameras', 'Smart Cameras'],
    Tracking: ['GPS Trackers', 'Activity Trackers'],
    'Smart Feeding': ['Smart Feeders', 'Smart Water Fountains'],
    'Smart Home': ['Automatic Doors', 'Smart Litter Boxes'],
  },
  'Other Pet Supplies': {
    Miscellaneous: [
      'Unclassified Pet Items',
      'Multi-Purpose Pet Products',
      'Other Pet Equipment',
    ],
  },
};

export const PET_SUPPLIES_SECTIONS = Object.keys(PET_SUPPLIES_CATEGORY_TREE);

export function isPetSuppliesListingCategory(category) {
  return category === 'Pet Supplies';
}

export function joinPetSubcategoryPath(parts) {
  return parts.filter(Boolean).join(PET_PATH_SEPARATOR);
}

export function parsePetSubcategoryPath(value) {
  if (!value) {
    return { section: '', group: '', product: '' };
  }
  const [section = '', group = '', product = ''] = String(value).split(PET_PATH_SEPARATOR);
  return { section, group, product };
}

export function getPetGroups(section) {
  return Object.keys(PET_SUPPLIES_CATEGORY_TREE[section] || {});
}

export function getPetProducts(section, group) {
  const node = PET_SUPPLIES_CATEGORY_TREE[section]?.[group];
  return Array.isArray(node) ? node : [];
}
